export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10381.2992840f.jpg";